import React from 'react'

const ShippingOne = () => {
  const shippingItems = [
    {
      id: 1,
      icon: 'ph-car-profile',
      title: 'Free Shipping',
      description: 'On all orders above $35',
    },
    {
      id: 2,
      icon: 'ph-hand-heart',
      title: '100% Satisfaction',
      description: 'Customer-first guarantee',
    },
    {
      id: 3,
      icon: 'ph-credit-card',
      title: 'Secure Payments',
      description: 'Protected transactions',
    },
    {
      id: 4,
      icon: 'ph-chats',
      title: '24/7 Support',
      description: 'Help whenever you need it',
    },
  ]

  return (
    <section className="shipping-bar" id="shipping">
      <style>{`
        .shipping-bar {
          padding: 12px 0;
          border-top: 1px solid #d8efd5;
          border-bottom: 1px solid #d8efd5;
          background: #f3faf2;
        }

        .shipping-bar__grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 0;
        }

        .shipping-bar__item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 20px;
          border-right: 1px solid #d8efd5;
          transition: background 0.18s ease;
        }

        .shipping-bar__item:last-child {
          border-right: none;
        }

        .shipping-bar__item:hover {
          background: #e8f5e5;
        }

        .shipping-bar__icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #fff;
          border: 1px solid #d8efd5;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          color: #299e60;
          flex-shrink: 0;
          transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease;
        }

        .shipping-bar__item:hover .shipping-bar__icon {
          background: #299e60;
          color: #fff;
          border-color: #299e60;
        }

        .shipping-bar__title {
          font-size: 13px;
          font-weight: 700;
          color: #14532d;
          margin: 0 0 2px;
          line-height: 1.3;
          white-space: nowrap;
        }

        .shipping-bar__desc {
          font-size: 12px;
          color: #3d7a52;
          margin: 0;
          line-height: 1.4;
          white-space: nowrap;
        }

        /* Tablet: 2x2 grid */
        @media (max-width: 991px) {
          .shipping-bar__grid {
            grid-template-columns: repeat(2, 1fr);
          }
          .shipping-bar__item {
            border-right: none;
            border-bottom: 1px solid #d8efd5;
            padding: 14px 16px;
          }
          .shipping-bar__item:nth-child(1),
          .shipping-bar__item:nth-child(2) {
            border-right: none;
          }
          .shipping-bar__item:nth-child(odd) {
            border-right: 1px solid #d8efd5;
          }
          .shipping-bar__item:nth-child(3),
          .shipping-bar__item:nth-child(4) {
            border-bottom: none;
          }
        }

        /* Mobile: compact horizontal pill per row */
        @media (max-width: 575px) {
          .shipping-bar {
            padding: 8px 0;
          }
          .shipping-bar__grid {
            grid-template-columns: 1fr 1fr;
            gap: 0;
          }
          .shipping-bar__item {
            gap: 8px;
            padding: 10px 12px;
          }
          .shipping-bar__icon {
            width: 32px;
            height: 32px;
            border-radius: 8px;
            font-size: 16px;
          }
          .shipping-bar__title {
            font-size: 12px;
            white-space: normal;
          }
          .shipping-bar__desc {
            font-size: 11px;
            white-space: normal;
          }
        }
      `}</style>

      <div className="container container-lg">
        <div className="shipping-bar__grid">
          {shippingItems.map((item) => (
            <div key={item.id} className="shipping-bar__item">
              <div className="shipping-bar__icon">
                <i className={`ph-fill ${item.icon}`} />
              </div>
              <div>
                <p className="shipping-bar__title">{item.title}</p>
                <p className="shipping-bar__desc">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ShippingOne